import { mergeStyleSets, Depths } from "@fluentui/react";
import type { ITheme } from "@fluentui/react";

export const getTaskCardStyles = (theme: ITheme) => {
  return mergeStyleSets({
    card: {
      backgroundColor: theme.palette.white,
      boxShadow: Depths.depth8,
      padding: "40px 20px",
      width: "100%",
      minWidth: "30%",
      minHeight: 200,
      textAlign: "center",
      cursor: "pointer",
      border: "1px solid transparent",
      transition: "all 0.2s ease",
      selectors: {
        ":hover": {
          boxShadow: Depths.depth16,
          backgroundColor: theme.palette.neutralLighter,
          border: `1px solid ${theme.palette.neutralTertiaryAlt}`,
        },
      },
    },
    iconContainer: {
      fontSize: 42,
      color: theme.palette.themePrimary,
      marginBottom: 15,
    },
    title: {
      color: theme.palette.themePrimary,
      fontWeight: 600,
      marginBottom: 10,
    },
  });
};
